import React from "react";

import { IFilterButton } from "./interface";
import { Container, PlusIcon } from "./styles";
import LupaWhite from "../../assets/svg/lupa-white.svg";

export const FilterButton: React.FC<IFilterButton> = ({
  onClick,
  id,
  style,
  widthHeight,
  isFilter,
  disabledFilterButton,
}) => {
  return (
    <Container
      data-testid="filter-button"
      id={id}
      onClick={onClick}
      style={style}
      widthHeight={widthHeight}
      isFilter={isFilter}
      disabled={disabledFilterButton}
    >
      <PlusIcon disabled={disabledFilterButton} id="filter_button">
        <img src={LupaWhite} alt="" height={"18px"} />
      </PlusIcon>
    </Container>
  );
};
